import "./ContactFloat.css";
import { FaWhatsapp } from "react-icons/fa";
import { SiGmail } from "react-icons/si";

const ContactFloat = () => {
  return (
    <div className="contact-float">


      <a
        href="https://wa.me/4407717819397"
        target="_blank"
        rel="noopener noreferrer"
        className="float-btn whatsapp"
      >
        <FaWhatsapp />
      </a>

      {/* Gmail */}
      <a
        href="mailto:afolabiogundiran121@gmail.com"
        className="float-btn gmail"
      >
        <SiGmail />
      </a>

    </div>
  );
};

export default ContactFloat;